import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/css/twglobal.css");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/js/react/common/components/ApolloWrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/peazy-dev/peazy-dev/ui/app.bookpeazy.com/src/js/react/common/fonts.css");
